import axios from 'axios';

const COURSES = '/v3/front/courses';
const SESSIONS = '/v3/front/session';
const SESSION_DATES = '/session-dates';
const DATES = '/dates';
const EVENTS = '/v3/front/events';
const EVENTS_POST = '/v3/front/events/get-events';

/**
 * @param {string} courseGuid
 * @returns
 */
export function getSessionDates(courseGuid) {
  return axios.get(COURSES + '/' + courseGuid + SESSION_DATES);
}

/**
 * @param {string} sessionId
 * @param {string} sessionDateId
 * @param {string} date
 * @returns
 */
export function putSessionDates(sessionId, sessionDateId, date) {
  return axios.put(SESSIONS + '/' + sessionId + DATES + '/' + sessionDateId, { date });
}

/**
 * @param {string[]} courseGuids
 * @param {string} from
 * @param {string} to
 * @returns
 */
export function getEvents(courseGuids, from, to) {
  return axios.post(EVENTS_POST, { from, to, course_guids: courseGuids });
}

/**
 * @param {string} courseGuid
 * @param {string} lessonGuid
 * @returns
 */
export function getSessions(courseGuid, lessonGuid) {
  return axios.get(`${COURSES}/${courseGuid}/items/${lessonGuid}/sessions`);
}

/**
 * @param {string} sessionId
 * @param {string} courseGuid
 * @returns
 */
export function getSessionResources(sessionId, courseGuid) {
  return axios.get(`v3/front/session/${sessionId}/resources?course_guid=${courseGuid}`);
}

/**
 * @param {string} courseGuid
 * @param {string} courseItemGuid
 * @returns
 */
export function getCourseItemSessions(courseGuid, courseItemGuid) {
  return axios.get(`v3/front/courses/${courseGuid}/items/${courseItemGuid}/sessions`);
}

/**
 * @param {string} sessionId
 * @param {string} courseGuid
 * @param {string} customized
 * @returns
 */
export function getItemSessionResources(sessionId, courseGuid, customized) {
  return axios.post(`v3/front/session/${sessionId}/get-resources`, {
    ...(customized && { customized_by: customized }),
    ...(courseGuid && { course_guid: courseGuid }),
  });
}
